import { KeywordSearch } from './subcomponents/KeywordSearch/KeywordSearch';

import type {
  MakeModelKeywordSearchProps,
  MakeModelOption,
} from './MakeModelKeywordSearch.typed';

/**
 * A search interface for filtering vehicles by make, model, and keywords.
 *
 * Renders different UI based on screen size.
 */
export const MakeModelKeywordSearch = (props: MakeModelKeywordSearchProps) => {
  const {
    value,
    modalDisplayConfig,
    dropdownDisplayConfig,
    minPrice,
    maxPrice,
    minYear,
    maxYear,
    makes,
    page,
    onSelectOption,
  } = props;

  const onSelect = (option: MakeModelOption) => {
    onSelectOption({
      label: option.label,
      make: option.value?.make,
      model: option.value?.model,
    });
  };

  return (
    <KeywordSearch
      value={value}
      onSelect={onSelect}
      minPrice={minPrice}
      maxPrice={maxPrice}
      minYear={minYear}
      maxYear={maxYear}
      initialItems={makes}
      modalDisplayConfig={modalDisplayConfig}
      dropdownDisplayConfig={dropdownDisplayConfig}
      page={page}
    />
  );
};
